import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { connect } from 'react-redux';
import { arrayPop, arrayPush, getFormValues } from 'redux-form';
import { getProp, __ } from '../../utilities';
import { MAX_PASSENGERS } from '../App/constants';
import { FORM_NAME } from '../Passengers/form';
import { getEnterStations, getStationTo } from './actions';
import {
  enterStationsIsFetchingSelector,
  enterStationsListSelector,
  toStationsIsFetchingSelector,
  toStationsListSelector,
} from './selectors';

export const ticketTypesByValue = {
  S: __('Jednosmerný'),
  R: __('Spiatočný'),
  O: __('Otvorený'),
};

const passengers = [];
for (let i = 1; i <= MAX_PASSENGERS; i++) {
  passengers.push({
    value: i,
    label: String(i),
  });
}

const DEFAULT_SEARCH_PARAMS = {
  count: 1,
  ticketType: 'S',
  direct: '0',
  stationFrom: null,
  stationTo: null,
  startDate: null,
  endDate: null,
};

class Form extends Component {
  constructor(props) {
    super(props);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.toogleCheckbox = this.toogleCheckbox.bind(this);
    this.isOutsideRange = this.isOutsideRange.bind(this);
    this.handleDatesChange = this.handleDatesChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setNumberOfPassegers = this.setNumberOfPassegers.bind(this);
    this.ticketTypes = Object.keys(ticketTypesByValue).map(key => {
      return {
        value: key,
        label: __(ticketTypesByValue[key]),
      };
    });
  }

  componentDidMount() {
    const { dispatch, value: { stationFrom } } = this.props;
    dispatch(getEnterStations());
    if (stationFrom) {
      dispatch(getStationTo(stationFrom));
    }
    this.setNumberOfPassegers();
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    if (nextProps.value.stationFrom !== this.props.value.stationFrom) {
      dispatch(getStationTo(nextProps.value.stationFrom));
    }
    this.setNumberOfPassegers(nextProps);
  }

  onChange(values) {
    // v onChange vratime vsetky parametre - aj tie, ktore este pouzivatel nevybral
    const allValues = Object.keys(DEFAULT_SEARCH_PARAMS).reduce(
      (acc, param) => {
        if (!(param in values)) {
          return { ...acc, [param]: DEFAULT_SEARCH_PARAMS[param] };
        }
        return acc;
      },
      values,
    );
    this.props.onChange(allValues);
    this.setNumberOfPassegers();
  }

  setNumberOfPassegers(props = this.props) {
    const {
      renderCustomForm,
      dispatch,
      passengerFormData,
      ...otherProps
    } = props;
    const count = parseFloat(getProp(otherProps, ['value', 'count']));
    const passengersLength = getProp(passengerFormData, ['passengers'], [])
      .length;
    if (count < passengersLength) {
      for (let i = count; i < passengersLength; i++) {
        props.dispatch(arrayPop(FORM_NAME, 'passengers'));
      }
    } else if (count > passengersLength) {
      for (let i = passengersLength; i < count; i++) {
        props.dispatch(arrayPush(FORM_NAME, 'passengers', {}));
      }
    }
  }

  handleSubmit(e) {
    this.props.onSubmit(e);
    this.setNumberOfPassegers();
  }

  toogleCheckbox(ev) {
    const { value } = this.props;
    const values = { ...value };
    values.direct = ev.target.checked ? '1' : '0';
    this.onChange(values);
  }

  handleChangeSelect(e) {
    const { target: { name, value } } = e;
    const values = { ...this.props.value };

    values[name] = value;
    this.onChange(values);
  }

  isOutsideRange(date) {
    const { value: { ticketType, firstWayDate } } = this.props;
    if (ticketType === 'B') {
      const momentObj = moment(firstWayDate);
      if (date.diff(momentObj) > 0) {
        return false;
      }
      return true;
    }
    return false;
  }

  handleDatesChange({ startDate: newStartDate, endDate: newEndDate }) {
    const values = { ...this.props.value };
    values.startDate = newStartDate;
    if (newEndDate) {
      values.endDate = newEndDate;
    } else {
      values.endDate = null;
    }
    if (values.endDate && values.endDate < newStartDate) {
      values.endDate = values.startDate.add(1, 'day');
    }
    this.onChange(values);
  }

  handleDateChange(date) {
    const values = { ...this.props.value };
    values.startDate = date;
    if (values.endDate < date) {
      values.endDate = date.clone().add(1, 'day');
    }
    this.onChange(values);
  }

  render() {
    const { renderCustomForm, ...otherProps } = this.props;

    return this.props.renderCustomForm({
      ...otherProps,
      isOutsideRange: this.isOutsideRange,
      onSumit: this.handleSubmit,
      ticketTypes:this.ticketTypes,
      passengers,
      handleChangeSelect: this.handleChangeSelect,
      handleDatesChange: this.handleDatesChange,
      handleDateChange: this.handleDateChange,
      toogleCheckbox: this.toogleCheckbox,
    });
  }
}

Form.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    direct: PropTypes.string,
    count: PropTypes.number,
    ticketType: PropTypes.string,
    stationFrom: PropTypes.string,
    stationTo: PropTypes.string,
    startDate: PropTypes.instanceOf(moment),
    endDate: PropTypes.instanceOf(moment),
    firstWayDate: PropTypes.instanceOf(moment),
  }),
  onSubmit: PropTypes.func.isRequired,
  isFetchingEntryStations: PropTypes.bool,
  entryStations: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }).isRequired,
        ).isRequired,
      ]).isRequired,
    }).isRequired,
  ),
  isFetchingToStations: PropTypes.bool,
  toStations: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }).isRequired,
        ).isRequired,
      ]).isRequired,
    }).isRequired,
  ),
  renderCustomForm: PropTypes.func.isRequired,
};

Form.defaultProps = {
  value: DEFAULT_SEARCH_PARAMS,
  entryStations: [],
  toStations: [],
  isFetchingEntryStations: true,
  isFetchingToStations: false,
};

const mapStateToProps = state => {
  return {
    isFetchingEntryStations: enterStationsIsFetchingSelector(state),
    entryStations: enterStationsListSelector(state),
    isFetchingToStations: toStationsIsFetchingSelector(state),
    toStations: toStationsListSelector(state),
    passengerFormData: getFormValues(FORM_NAME)(state),
  };
};

export default connect(mapStateToProps)(Form);



// WEBPACK FOOTER //
// ./src/containers/ConnectionForm/index.js